module.exports = __webpack_public_path__ + "img/to_rechargepray_en.fd22e782.png";